import React from 'react'
import styles from './Chip.module.sass'

interface Props {
  label?: string
  size?: 'lg' | 'sm'
  className?: string
  href?: string
  onClick?: (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void
}

const Chip = (props: Props) => {
  const { label = undefined, size = 'lg', className = '', href = '', onClick = undefined } = props

  return label ? (
    href ? (
      <a
        className={`${styles.root} ${styles[`root--${size}`]} ${className}`}
        href={href}
        onClick={onClick}
      >
        {label}
      </a>
    ) : (
      <div className={`${styles.root} ${styles[`root--${size}`]} ${className}`}>{label}</div>
    )
  ) : (
    <></>
  )
}

export default Chip
